import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { EnergyReadsComponent } from './energy-reads/energy-reads.component';
import { PowerDemandComponent } from './power-demand/power-demand.component';
import { VoltageCurrentComponent } from './voltage-current/voltage-current.component';

@Component({
  selector: 'app-load-profile',
  standalone: true,
  imports: [CommonModule, TranslateModule, EnergyReadsComponent, PowerDemandComponent, VoltageCurrentComponent],
  templateUrl: './load-profile.component.html',
  styleUrl: './load-profile.component.scss',
})
export class LoadProfileComponent {
  @Input() meterId = '';

  subTabs = [
    { id: 'Energy Reads', labelKey: 'ENERGY_READS' },
    { id: 'Power Demand', labelKey: 'POWER_DEMAND' },
    { id: 'Voltage Current', labelKey: 'VOLTAGE_CURRENT' },
  ];
  activeSubTab = this.subTabs[0].id;

  selectSubTab(tab: string) {
    this.activeSubTab = tab;
  }
}
